"use client";

import { useRouter } from "next/navigation";
import { useEffect } from "react";
import { useSelector } from "react-redux";

import QuestionLayout from "@/app/layout/question";
import { useWizard } from "@/app/shared-providers/wizard-context-provider";
import { RootState } from "@/store/root-reducer";
import { hidePersonalDetailsFields } from "@/utils/organiser.utils";

import DescriptionSection from "./components/description-section";
import FormSection from "./components/form-section";
import useTravellersRequiredInformationHook from "./hooks/use-travellers-required-information.hook";
import { useTravellersRequiredInformation } from "./provider/travellers-required-information.provider";

function TravellersRequiredInformationComponent() {
  const router = useRouter();
  const { magnoliaData } = useTravellersRequiredInformation();
  const { isFooterLoading, handleBackButton, handleContinueButton } =
    useTravellersRequiredInformationHook();

  const { current } = useWizard();
  const quoteData = useSelector((state: RootState) => state.quote);
  const { experimentDetails } = quoteData?.attributes || {};
  const continueText = magnoliaData?.footer?.continueButtonText ?? "Continue";

  const isVariantFlow = hidePersonalDetailsFields(experimentDetails);

  // Redirect if NOT in variant flow
  useEffect(() => {
    if (!isVariantFlow) {
      const redirectPath = "/";
      router.push(redirectPath);
    }
  }, [isVariantFlow, current?.prev, router]);

  // Don't render page content if NOT in variant flow
  if (!isVariantFlow) {
    return null;
  }

  return (
    <QuestionLayout
      formSection={<FormSection />}
      descriptionContent={<DescriptionSection />}
      footer={{
        isHideFooterBack: false,
        isLoading: isFooterLoading,
        isDisabledBack: false,
        isDisabledContinue: isFooterLoading,
        footerActionBack: handleBackButton,
        footerActionContinue: handleContinueButton,
        id: "required-information",
        brand: "staysure",
        ctaButtonText: continueText,
      }}
      progressBarPercent={current?.progressBarPercentage ?? -1}
      scrollRefs={[]}
    />
  );
}

export default TravellersRequiredInformationComponent;
